import React from 'react';
import loadable from 'react-loadable';
import Loading from '../components/loading';

const loadableEmbellish = (loader: any) => {
    return loadable({
        loader,
        loading: () => <Loading />,
        timeout: 10000,
    });
};
const loadableNoloading = (loader: any) => {
    return loadable({
        loader,
        loading: () => null,
        timeout: 10000,
    });
};

export default [
    {
        // 公共隐私政策
        path: '/solo/privacy',
        name: 'soloPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/privacy')),
    },
    {
        // 公共隐私政策--薪税师
        path: '/solo/privacy-newtax',
        name: 'soloPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/privacy')),
    },
    {
        // 公共服务条款
        path: '/solo/policy',
        name: 'soloPolicy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/policy')),
    },
    {
        // 公共服务条款--薪税师
        path: '/solo/policy-newtax',
        name: 'soloPolicy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/policy')),
    },

    // --------------  构建新的myun , areteUp, booker 隐私条款，与隐私协议 ----------------------
    {
        // myun服务条款policy
        path: '/policy-privacy/myunPolicy',
        name: 'policyPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/policy-privacy/myunPolicy')),
    },
    {
        // myun隐私政策privacy
        path: '/policy-privacy/myunPrivacy',
        name: 'policyPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/policy-privacy/myunPrivacy')),
    },
    {
        // areteUp服务条款policy
        path: '/policy-privacy/areteUpPolicy',
        name: 'policyPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/policy-privacy/areteUpPolicy')),
    },
    {
        // areteUp隐私政策privacy
        path: '/policy-privacy/areteUpPrivacy',
        name: 'policyPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/policy-privacy/areteUpPrivacy')),
    },
    {
        // booker服务条款policy
        path: '/policy-privacy/bookerPolicy',
        name: 'policyPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/policy-privacy/bookerPolicy')),
    },
    {
        // booker隐私政策privacy
        path: '/policy-privacy/bookerPrivacy',
        name: 'policyPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/policy-privacy/bookerPrivacy')),
    },
    // --------------  CRM渠道落地页面集合 ----------------------
    {
        // CRM渠道落地页面
        path: '/channelCode',
        name: 'channelCode',
        exact: true,
        component: loadableEmbellish(() => import('../containers/channel-code')),
    },
    {
        //CRM 推广页面--财菁节宣传物料
        path: '/crmPromotion',
        name: 'crmPromotion',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion')),
    },
    {
        //CRM 推广页面--领象汇线下推荐
        path: '/crmPromotion2',
        name: 'crmPromotion2',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion2')),
    },
    {
        //CRM 推广页面--领象汇邮件EDM
        path: '/crmPromotion3',
        name: 'crmPromotion3',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion3')),
    },
    {
        //CRM 推广页面--领象汇公众号
        path: '/crmPromotion4',
        name: 'crmPromotion4',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion4')),
    },
    {
        //CRM 推广页面--教师节Gala
        path: '/crmPromotion5',
        name: 'crmPromotion5',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion5')),
    },
    {
        //CRM 推广页面--教师节Gala（广州场）
        path: '/crmPromotion6',
        name: 'crmPromotion6',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion6')),
    },
    {
        //CRM 推广页面--教师节Gala（深圳场）
        path: '/crmPromotion7',
        name: 'crmPromotion7',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion7')),
    },
    {
        //CRM 推广页面--课程智能总结
        path: '/crmPromotion8',
        name: 'crmPromotion8',
        exact: true,
        component: loadableEmbellish(() => import('../containers/crm-promotion8')),
    },
    // --------------  其它历史的的路由页面 --------------------------------
    {
        // 腾讯会议讲师登录
        path: '/',
        name: 'txLogin',
        exact: true,
        component: loadableEmbellish(() => import('../containers/tx-login')),
    },
    {
        //简搭页面后台管理系统预览H5
        path: '/custom-page',
        name: 'customPage',
        exact: true,
        component: loadableEmbellish(() => import('../containers/custom-page')),
    },
    {
        // app下载
        path: '/app-download',
        name: 'appDownload',
        exact: true,
        component: loadableEmbellish(() => import('../containers/app-download')),
    },
    {
        // glive2--app直播间中转页
        path: '/glive2-blank',
        name: 'glive2-blank',
        exact: true,
        component: loadableEmbellish(() => import('../containers/glive2-blank')),
    },
    {
        // glive直播空白页--薪税师
        path: '/gliveIframe',
        name: 'glive-newtax',
        exact: true,
        component: loadableEmbellish(() => import('../containers/glive-iframe')),
    },
    {
        // 业务工作台-glive2高顿视频--iframe
        path: '/gdPlayIframe',
        name: 'gdPlayIframe',
        exact: true,
        component: loadableEmbellish(() => import('../containers/gdPlay-iframe')),
    },
    {
        // 华瀚iframe页面
        path: '/huahan',
        name: 'huahan',
        exact: true,
        component: loadableEmbellish(() => import('../containers/huahan')),
    },
    {
        // 培养方案报告预览页面
        path: '/reportPreview',
        name: 'reportPreview',
        exact: true,
        component: loadableNoloading(() => import('../containers/report-preview')),
    },
    {
        // 404
        path: '/404',
        name: '404',
        exact: true,
        component: loadableEmbellish(() => import('../containers/page404')),
    },
];
